import React from 'react';

class ScanImg extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            src: null,
            error: null
        }
    }

    componentDidMount(){
        var self = this;
        self.props.gate.getCardImgURL(
            self.props.corpus, 
            self.props.code, 
            (src) => {
                self.setState({"src": src});
            },
            (err) => {
                self.setState({"error": err});
            }
        );
    }

    render(){
        if(this.state.src){
            return <img className="img-fluid" src={this.state.src}/>;
        }
        else{
            if(this.state.error){
                return <i class="fas fa-exclamation-circle error"></i>
            }
            return <i className="fas fa-circle-notch fa-spin"></i>;
        }
    }
}

export default ScanImg;